import { BtnAccent } from '../ui/BtnAccent'
import { BtnGhost } from '../ui/BtnGhost'
const cx = 'max-w-[1100px] mx-auto px-5 sm:px-8'

export function Hero() {
  return (
    <section className="pt-[100px] sm:pt-[140px] pb-16 sm:pb-[100px] text-center border-b border-ds-border">
      <div className={cx}>
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-ds-border-mid rounded-sharp px-3 py-[5px] mb-10">
          <span className="w-1.5 h-1.5 rounded-full bg-ds-red flex-shrink-0 inline-block" />
          <span className="font-display font-bold text-label tracking-label uppercase text-ds-muted">
            Editor de guiones · Para YouTube
          </span>
        </div>

        <h1 className="font-display font-black text-display-xl tracking-tight2 uppercase text-ds-text mb-3">
          Guiones que suenan a ti.
          <br />
          <span className="italic text-ds-red">No a ChatGPT.</span>
        </h1>

        <p className="font-display font-bold text-[14px] sm:text-[18px] tracking-[0.06em] uppercase text-ds-muted mb-3 px-4">
          Tu voz, tu ritmo, tu vocabulario — en cada guion.
        </p>
        <p className="font-sans text-[14px] sm:text-[16px] text-ds-muted mb-10 sm:mb-12 px-4 leading-[1.6]">
          De la idea al vídeo en 30 minutos, no en 3 horas.
        </p>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4 max-w-[320px] sm:max-w-none mx-auto">
          <BtnAccent to="/auth" className="text-[15px] px-8 py-[14px] text-center">
            Probar en mi voz →
          </BtnAccent>
          <BtnGhost to="/auth" className="text-center">
            Ver la diferencia
          </BtnGhost>
        </div>

        <div className="flex items-center justify-center gap-x-6 gap-y-2 mt-8 flex-wrap px-4">
          {['10 créditos gratis al mes', 'Sin tarjeta de crédito', 'Setup en 3 minutos'].map(t => (
            <span
              key={t}
              className="flex items-center gap-1.5 font-display font-bold text-label tracking-[0.08em] uppercase text-ds-muted"
            >
              <span className="w-1 h-1 rounded-full bg-ds-border-mid inline-block flex-shrink-0" />
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  )
}
